export const TEST_ID = 'doppio-radio';
//# sourceMappingURL=types.js.map